export default __webpack_public_path__ + "static/media/my-leaves-blue.6149469f.svg";